import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../config";
import { getAuditTrailData } from "../util/getAuditTrailData";

const baseUrl = BASE_URL + "form-tree"; // keep endpoint name same unless API changes

// 📌 Create Section Form (POST)
export const createSectionForm = createAsyncThunk(
  "sectionForm/create",
  async ({sectionFormData,version_content}, { rejectWithValue }) => {
    const ad = await getAuditTrailData({
      action: "CREATE_FORM",
      comment: "Created Form",
      version_content
    })

    const payload = {
      ...sectionFormData,
      audit_trail_data:ad
    }
    try {
      const response = await axios.post(`${baseUrl}/create`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error creating section form"
      );
    }
  }
);

// 📌 Update Section Form (PUT)
export const updateSectionForm = createAsyncThunk(
  "sectionForm/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${baseUrl}/update/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error updating section form"
      );
    }
  }
);

// 📌 Get All Section Forms (GET)
export const getAllSectionForms = createAsyncThunk(
  "sectionForm/getAll",
  async ({ limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/get-all?limit=${limit}&offset=${offset}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching section forms"
      );
    }
  }
);

// 📌 Delete Section Form (DELETE)
export const deleteSectionForm = createAsyncThunk(
  "sectionForm/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${baseUrl}/delete/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error deleting section form"
      );
    }
  }
);

// 🛠 Section Form Slice
const sectionFormSlice = createSlice({
  name: "sectionForm",
  initialState: {
    sectionForms: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createSectionForm.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSectionForm.fulfilled, (state, action) => {
        state.loading = false;
        state.sectionForms.push(action.payload);
      })
      .addCase(createSectionForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "An error occurred";
      })
      .addCase(updateSectionForm.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSectionForm.fulfilled, (state, action) => {
        state.loading = false;
        state.sectionForms = state.sectionForms.map((form) =>
          form.id === action.payload.id ? action.payload : form
        );
      })
      .addCase(updateSectionForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "An error occurred";
      })
      .addCase(getAllSectionForms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllSectionForms.fulfilled, (state, action) => {
        state.loading = false;
        state.sectionForms = action.payload.results;
      })
      .addCase(getAllSectionForms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "An error occurred";
      })
      .addCase(deleteSectionForm.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSectionForm.fulfilled, (state, action) => {
        state.loading = false;
        state.sectionForms = state.sectionForms.filter(
          (form) => form.id !== action.payload
        );
      })
      .addCase(deleteSectionForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "An error occurred";
      });
  },
});

export default sectionFormSlice.reducer;
